var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "position-relative d-flex flex-column",
      attrs: { id: "q-app" },
    },
    [
      _c("b-overlay", {
        staticClass: "h-100 w-100 position-absolute",
        attrs: { show: _vm.isPageLoading },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [_c("app-spinner", { attrs: { size: 32 } })]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isLoggedIn && !_vm.isWidget && !_vm.suspended
        ? _c("header-notification", { staticClass: "flex-grow-0" })
        : _vm._e(),
      _vm.cookieValidated
        ? _c("router-view", { staticClass: "flex-grow-1 overflow-hidden" })
        : _vm._e(),
      _c("portal-target", { attrs: { name: "app", multiple: "" } }),
      !_vm.isWidget
        ? _c("action-notification", { attrs: { id: "system" } })
        : _vm._e(),
      !_vm.isWidget
        ? _c("action-notification", { attrs: { id: "sms" } })
        : _vm._e(),
      !_vm.isWidget
        ? _c("action-notification", { attrs: { id: "call" } })
        : _vm._e(),
      !_vm.isWidget
        ? _c("action-notification", { attrs: { id: "voicemail" } })
        : _vm._e(),
      !_vm.isWidget
        ? _c("action-notification", { attrs: { id: "mention" } })
        : _vm._e(),
      !_vm.isWidget
        ? _c("action-notification", { attrs: { id: "reminder" } })
        : _vm._e(),
      (_vm.isWidget ? _vm.isSoftphoneWidget : true)
        ? _c("action-notification", {
            attrs: { id: "incomingCall", position: "b-toaster-top-center" },
          })
        : _vm._e(),
      _vm.isIntercomEnabled && !_vm.isWidget ? _c("intercom") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }